<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>SKU(Stock - Keeping Unit)</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <!-- <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" (click)="GoToCreate($event)"
                                        class="p-button-success p-mr-2"></button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <table class="normal-table">
                            <tr>

                                <td style="width:17%" class="text-right">
                                    Temp Customer <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <input type="text" disabled pInputText>
                                        <button class="p-inputgroup-addon p-button" title="Add" type="button"
                                            (click)="showBasicDialog()">
                                            <i class="las la-search"></i>
                                        </button>
                                    </div>

                                </td>
                                <td class="text-right">Temp Customer Site <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td></td>
                                <td></td>

                            </tr>
                            <tr>
                                <td class="text-right">Type <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">UOM <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true" [options]="_Uom" optionValue="uomid"  optionLabel="uomname"></p-dropdown></td>
                                <td class="text-right">Length<span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                            </tr>
                            <tr>
                                <td class="text-right">Breadth <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Height<span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Based On<span class="hlt-txt">*</span></td>
                                <td><p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true" [options]="_Basedon" optionValue="id"  optionLabel="name"></p-dropdown></td>
                            </tr>
                            <tr>
                                <td class="text-right">Weight <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">% Of Contributions <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Photo Attached<span class="hlt-txt">*</span></td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <div class="browse-links">
                                                <!-- <p-button label="Link" styleClass="p-button-link"></p-button> -->
                                            </div>
                                        </span>
                                        <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only"
                                            pTooltip="Browse File" tooltipPosition="top" mode="basic" name="demo[]"
                                            accept="image/*" maxFileSize="1000000" chooseLabel="" #fileUpload>
                                        </p-fileUpload>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Cancel"
                                            tooltipPosition="top">
                                            <i class="las la-times"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Add" class="p-button-success"></button>
                                    <button pButton label="Clear" class="p-button-warning"></button>
                                </td>
                            </tr>
                        </table>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px">
                                <!-- <p-table #dt [value]="agentListGrid" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true"> -->
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width: 100px;">
                                        <col style="width: 100px;">
                                        <col style="width:250px">
                                        <col style="width:100px">
                                        <col style="width: 100px;">
                                        <col style="width: 100px;">
                                        <col style="width: 100px;">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <!-- <col style="width:250px">
                                        <col style="width:250px"> -->
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                        <th style="text-align: center" pSortableColumn="agentNo" rowspan="2">S. No
                                            <p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName" rowspan="2">Type <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th style="text-align: center;" colspan="6">CFT

                                        </th>
                                        <th pSortableColumn="agentName" rowspan="2">% Of Contributions <p-sortIcon
                                                field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName" rowspan="2">Photo Attached <p-sortIcon
                                                field="agentName">
                                            </p-sortIcon>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th pSortableColumn="agentName">UOM <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">L <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">B <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">H <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Weight Based On <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Weight <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_agentListGrid>
                                    <tr>
                                        <td style="text-align: center">
                                            <button pButton pRipple title="Add" icon="pi pi-plus"
                                                class="p-button-success p-mr-2"></button>
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>

                                        <td style="text-align: center;">
                                            {{_agentListGrid.agentNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.fatherName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.pincode}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            <div class="p-inputgroup">
                                                <span class="p-float-label">
                                                    <div class="browse-links">
                                                        <!-- <p-button label="Link" styleClass="p-button-link"></p-button> -->
                                                    </div>
                                                </span>
                                                <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only"
                                                    pTooltip="Browse File" tooltipPosition="top" mode="basic"
                                                    name="demo[]" accept="image/*" maxFileSize="1000000" chooseLabel=""
                                                    #fileUpload>
                                                </p-fileUpload>
                                                <button class="p-inputgroup-addon p-button" pTooltip="Cancel"
                                                    tooltipPosition="top">
                                                    <i class="las la-times"></i>
                                                </button>
                                            </div>
                                            <!-- {{_agentListGrid.locInterest}} -->
                                        </td>



                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Volume Distrubution </h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            
                            <tr>
                                <td class="text-right">Hub <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Quantity <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td>
                                    <!-- <input type="file"  (change)="addfile($event)" placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">    -->
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Add" class="p-button-success"></button>
                                    <button pButton label="Clear" class="p-button-warning"></button>
                                </td>
                            </tr>
                        </table>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px"> -->
                            <p-table #dt [value]="VolumeList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">
                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:100px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;width: 100px;">Action</th>
                                        <th style="text-align: center;width: 100px;" pSortableColumn="agentNo">S. No
                                            <p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentNo">Hub <p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">% of Qty <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_agentListGrid>
                                    <tr>
                                        <td style="text-align: center">
                                            <button pButton pRipple title="Add" icon="pi pi-plus"
                                                class="p-button-success p-mr-2"></button>
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>

                                        <td style="text-align: center">
                                            {{_agentListGrid.sno}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.hub}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.quantity}}
                                        </td>

                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments </h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">

                            <tr>
                                <td class="text-right">Comments<span class="hlt-txt">*</span></td>
                                <!-- <td> -->
                                <td colspan="5"><textarea inputId="textarea" rows="2" cols="30"
                                        pInputTextarea></textarea></td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Save" class="p-button-success" icon="las la-check"></button>
                                    <button pButton label="Clear" class="p-button-warning" icon="las la-broom"></button>
                                </td>
                            </tr>
                        </table>
                        <p-dialog header="Customer" [(visible)]="displayBasic" [modal]="true"
                            [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                            <ng-template pTemplate="content">
                                <div class="popup-body">
                                    <div class="search-container">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <input type="text" id="inputtext" pInputText>
                                            </span>
                                            <button class="p-inputgroup-addon p-button" title="Search">
                                                <i class="pi pi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <p-table [value]="_Expenses" selectionMode="single"
                                            [(selection)]="selectedRequest" (onRowSelect)="onRowSelectPopup($event)"
                                            (onRowUnselect)="onRowUnSelectPopup($event)" [paginator]="true" [rows]="10">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <!-- <th *ngIf="_action != 'view'">
                                            </th> -->
                                                    <th pSortableColumn="requestno">Customer Name <p-sortIcon
                                                            field="requestno">
                                                        </p-sortIcon>
                                                    </th>
                                                    <!-- <th pSortableColumn="requestedbranch">Customer Tally ID
                                                    <p-sortIcon field="requestedbranch">
                                                    </p-sortIcon>
                                                </th> -->
                                                    <th pSortableColumn="requestperson">Customer Type <p-sortIcon
                                                            field="requestperson">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Is Transporter
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Billing Cycle
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Pan No
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>


                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData let-_Expense>
                                                <tr>
                                                    <!-- <td style="text-align: center" *ngIf="_action != 'view'">
                                                <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                            </td> -->
                                                    <td>{{_Expense.pettycashsettlementid}}</td>
                                                    <td>{{_Expense.settlementamount}}</td>
                                                    <!-- <td>{{_Expense.balanceamount}}</td> -->
                                                    <td>{{_Expense.settlementamount}}</td>
                                                    <td>{{_Expense.balanceamount}}</td>
                                                    <td>{{_Expense.balanceamount}}</td>

                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>